// import _ from "../../constants/Translations";
import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import JSRSASign from "jsrsasign";
import { AUTHCENTRAL_SERVICE_URL } from "../../constants/ServiceUrls";
import {
  getAssignedRolesForAuthorisation,
  getAssignedClientsForUser,
} from "../Management/UserService";
import { getUserProfile } from "../Management/UserProfileService";

export let lastError = "";

class AuthService {
  isAuthenticated = false;
  redirectTo2FA = false;
  twoFAuthType = 0;
  twoFATOTPRequiresConfiguration = false;
  userDetails;
  decodeToken = (token) => {
    const arrToken = token.split(".");
    const Claim = JSRSASign.b64utos(arrToken[1]);
    return JSRSASign.jws.JWS.readSafeJSONString(Claim);
  };

  getUserFromLocalStorage = async () => {
    this.isAuthenticated = false;

    if (typeof localStorage === "object") {
      if (localStorage.getItem("token") !== null) {
        const isAlive = localStorage.getItem("alive");
        let isRefreshed = sessionStorage.getItem("refreshed");
        if (sessionStorage.getItem("refreshTime") && isRefreshed) {
          const refreshTime = sessionStorage.getItem("refreshTime");
          const diff = Date.now() - parseFloat(refreshTime);
          if (diff > 10000) {
            isRefreshed = false;
          }
        }

        if (isAlive || isRefreshed) {
          localStorage.setItem("alive", true);

          const token = localStorage.getItem("token");
          const UserDetails = await this.getUserDetail(token);

          this.userDetails = UserDetails;
        } else {
          localStorage.removeItem("token");
        }
      }
    }
    sessionStorage.removeItem("refreshed");
    sessionStorage.removeItem("refreshTime");
  };

  getUserDetail = async (token) => {
    const UserDetails = this.decodeToken(token);
    if (UserDetails["2FA_Status"] && UserDetails["2FA_Status"] === "enabled") {
      this.isAuthenticated = false;
      this.redirectTo2FA = true;
      this.twoFAuthType = UserDetails["2FA_Type"];
      this.twoFATOTPRequiresConfiguration =
        UserDetails["2FA_TOTPConfigIncomplete"] &&
        UserDetails["2FA_TOTPConfigIncomplete"] === "true";
    } else {
      this.isAuthenticated = true;
      this.redirectTo2FA = false;
      await Promise.all([
        AxiosPost(
          `${AUTHCENTRAL_SERVICE_URL}api/Auth/GetClientFeatureAccess`,
          {
            clientId: 0,
          }
        ).then((features) => (UserDetails.features = features)),
        getAssignedRolesForAuthorisation().then(
          (permits) => (UserDetails.permits = permits)
        ),
        getUserProfile().then((UserProfile) => {
          UserDetails.UserProfile = UserProfile;
          getAssignedClientsForUser().then(
            (clients) => (UserDetails.UserProfile.clients = clients)
          );
        }),
      ]);
    }
    return UserDetails;
  };

  authenticate = (
    email,
    password,
    isExternal,
    externalAuthenticationType,
    additionalSignInParams,
    cb
  ) => {
    if (
      !email ||
      (!isExternal && !password) ||
      typeof email !== "string" ||
      typeof password !== "string"
    ) {
      this.isAuthenticated = false;
      lastError = "LoginEmpty";
    } else {
      AxiosPost(`${AUTHCENTRAL_SERVICE_URL}api/Auth/SignIn`, {
        email,
        password,
        isExternal,
        externalAuthenticationType,
        additionalSignInParams,
      })
        .then(async (res) => {
          if (res.error) {
            this.isAuthenticated = false;
          } else {
            if (typeof localStorage === "object") {
              localStorage.setItem("token", res);
              localStorage.setItem("alive", true);
            }

            const UserDetails = await this.getUserDetail(res);
            lastError = "";
            this.userDetails = UserDetails;
          }
          cb({
            isAuthenticated: this.isAuthenticated,
            userDetails: this.userDetails,
            redirectTo2FA: this.redirectTo2FA,
            twoFAuthType: this.twoFAuthType,
            twoFATOTPRequiresConfiguration: this.twoFATOTPRequiresConfiguration,
          });
        })
        .catch((res) => {
          this.isAuthenticated = false;
          lastError = "LoginUnknownUser";
          cb({
            isAuthenticated: this.isAuthenticated,
          });
        });
    }
  };

  requestAccessToken(requestAccessTokenParametersEntities) {
    return AxiosPost(`${AUTHCENTRAL_SERVICE_URL}api/Auth/RequestAccessToken`, {
      requestAccessTokenParametersEntities,
    });
  }

  async signInWithAccessToken(accessToken, cb) {
    await AxiosPost(
      `${AUTHCENTRAL_SERVICE_URL}api/Auth/SignInWithAccessToken?accessToken=${accessToken}`
    )
      .then(async (res) => {
        if (res.error) {
          this.isAuthenticated = false;
        } else {
          if (typeof localStorage === "object") {
            localStorage.setItem("token", res);
            localStorage.setItem("alive", true);
          }
          const UserDetails = await this.getUserDetail(res);
          lastError = "";
          this.isAuthenticated = true;
          this.userDetails = UserDetails;
        }
        cb({
          isAuthenticated: this.isAuthenticated,
          userDetails: this.userDetails,
        });
      })
      .catch((res) => {
        this.isAuthenticated = false;
        lastError = "LoginUnknownUser";
        cb({
          isAuthenticated: this.isAuthenticated,
        });
      });
  }

  async generateNewToken(cb) {
    await AxiosGet(`${AUTHCENTRAL_SERVICE_URL}api/Auth/GenerateNewToken`)
      .then(async (res) => {
        if (res.error) {
          this.isAuthenticated = false;
        } else {
          if (typeof localStorage === "object") {
            localStorage.setItem("token", res);
            localStorage.setItem("alive", true);
          }
          const UserDetails = await this.getUserDetail(res);
          lastError = "";
          this.isAuthenticated = true;
          this.userDetails = UserDetails;
        }
        cb({
          isAuthenticated: this.isAuthenticated,
          userDetails: this.userDetails,
        });
      })
      .catch((res) => {
        this.isAuthenticated = false;
        lastError = "LoginUnknownUser";
        cb({
          isAuthenticated: this.isAuthenticated,
        });
      });
  }

  async signIn2FA(signInUserWith2FAParameters, cb) {
    await AxiosPost(
      `${AUTHCENTRAL_SERVICE_URL}api/Auth/SignIn2FA`,
      signInUserWith2FAParameters
    )
      .then(async (res) => {
        if (res.error) {
          this.isAuthenticated = false;
        } else {
          if (typeof localStorage === "object") {
            localStorage.setItem("token", res);
            localStorage.setItem("alive", true);
          }
          const UserDetails = await this.getUserDetail(res);
          lastError = "";
          this.isAuthenticated = true;
          this.userDetails = UserDetails;
        }
        cb({
          isAuthenticated: this.isAuthenticated,
          userDetails: this.userDetails,
        });
      })
      .catch((res) => {
        this.isAuthenticated = false;
        lastError = "LoginUnknownUser";
        cb({
          isAuthenticated: this.isAuthenticated,
        });
      });
  }

  signout() {
    this.isAuthenticated = false;
    return AxiosGet(`${AUTHCENTRAL_SERVICE_URL}api/Auth/SignOut`);
  }
}
const service = new AuthService();
export default service;
